const CheckoutPhoneFooter = () => {
    return (
        <div
            className="w-full flex-1 mt-2 md:mt-0 bg-cartItem rounded-[2rem] px-8 py-2 flex flex-col items-center justify-center">
            <div className="flex items-center justify-center gap-2">
                <p className="mt-1 text-sm text-gray-500">Пожалуйста, введите 4 цифры кода или введите последние 4 цифры номера телефона, с которого вам поступит звонок, чтобы подтвердить вашу личность.</p>
            </div>
        </div>
    );
};

export default CheckoutPhoneFooter;
